const fixedHeader = () => {
  if ($(window).scrollTop() >= 100) {
    $('.header').addClass('header--sticky');
  }
  else {
    $('.header').removeClass('header--sticky');
  }
}

const events = () => {
  // $(window).on('scroll', fixedHeader);
  window.addEventListener('scroll', fixedHeader, { passive: true });
}

const init = () => {
  fixedHeader();
  events();
}

export default init;
